import React, { useState } from 'react';
import apiService from "../Common/Configurations/APIService";
import config from "../Common/Configurations/APIConfig";
import DefaultData from '../CompanyData/DefaultData';

export default function ForgotPasswordModal({ show, onClose, onSwitchToLogin }) {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email) {
            setError('Please enter your email address.');
            return;
        }

        setIsLoading(true);
        setError('');
        setSuccessMessage('');

        const formData = {
            "email": email,
            
            "domainUrl": window.location.origin 
        };

        try {
            const result = await apiService.post(config.SENDRESETLINK, formData);
            setSuccessMessage(result.message || "If an account with this email exists, a password reset link has been sent.");
            setEmail(''); // Clear input on success
        } catch (err) {
            setError(err.response?.data?.message || 'Something went wrong. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    if (!show) {
        return null;
    }

    const handleClose = () => {
        setEmail('');
        setError('');
        setSuccessMessage('');
        setIsLoading(false);
        onClose();
    };

    return (
        <>
            <div className="modal-backdrop fade show"></div>
            <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Reset Password</h5>
                            <button type="button" className="btn-close" onClick={handleClose}></button>
                        </div>
                        <div className="modal-body">
                            <p className="text-muted text-center">Enter your email to receive a password reset link.</p>
                            
                            {error && <div className="alert alert-danger">{error}</div>}
                            {successMessage && <div className="alert alert-success">{successMessage}</div>}

                            <form onSubmit={handleSubmit} noValidate>
                                <div className="mb-3">
                                    <label htmlFor="reset-email" className="form-label">Email Address</label>
                                    <input 
                                        className="form-control" 
                                        id="reset-email" 
                                        name="email" 
                                        type="email" 
                                        value={email} 
                                        onChange={(e) => setEmail(e.target.value)} 
                                        placeholder="Enter your registered email" 
                                        disabled={isLoading || successMessage} // Disable after success
                                    />
                                </div>
                                <div className="mt-4">
                                    <button type="submit" className="btn btn-success w-100" disabled={isLoading || successMessage}>
                                        {isLoading ? 'Sending...' : 'Send Reset Link'}
                                    </button>
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer justify-content-center">
                            <p className="mb-0">
                                Remember your password?{' '}
                                <button className="btn btn-link p-0 fw-semibold text-decoration-underline" onClick={onSwitchToLogin}>
                                    Sign In
                                </button>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}